import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { BaseDataService, HttpResponsesHandlersFactory, IHttpResponsesHandler } from "@bbwt/modules/data-service";
import { AppOnlineStateService } from "@main/pwa/app-online-state.service";
import * as signalR from "@microsoft/signalr";
import { MessageService } from "primeng/api";
import { Observable, Subject } from "rxjs";
import { FormIOInboxItem } from "./formio-inbox-item";
import { PagedCrudService } from "@features/grid";

@Injectable({
    providedIn: "root"
})
export class FormIOInboxService extends PagedCrudService<FormIOInboxItem> {
    entityTitle = "Forms Inbox Item";
    readonly url = "api/formio-inbox";
    private _onUpdated = new Subject<number>();
    protected _hubConnection: signalR.HubConnection;
    protected _onError = new Subject<string>();

    get newItems() {
        return this._onUpdated.asObservable();
    }

    get getError() {
        return this._onError.asObservable();
    }


    constructor(
        http: HttpClient,
        handlersFactory: HttpResponsesHandlersFactory,
        protected messageService: MessageService,
        private appOnlineStateService: AppOnlineStateService
    ) {
        super(http, handlersFactory);

        this._onUpdated = new EventEmitter<number>();

        this.initHubConnection();
    }

    public checkHubConnection() {
        if (this._hubConnection.state === signalR.HubConnectionState.Disconnected) {
            this._hubConnection.start();
        }
    }

    protected handleRequest<TResult>(request: Observable<TResult>, responseHandler?: IHttpResponsesHandler): Promise<TResult> {
        this.checkHubConnection();
        return super.handleRequest(request, responseHandler);
    }

    protected initHubConnection(): void {
        this._hubConnection = new signalR.HubConnectionBuilder()
            .withUrl("api/formio-inbox")
            .withAutomaticReconnect()
            .configureLogging(signalR.LogLevel.None)
            .build();

        this._hubConnection.onreconnected(() => {
            this.getInboxItemsTotal().then(data => {
                this.notify(data);
            });
        });

        this._hubConnection.on("Total", (unarchived: Notification[]) => {
            // Instead of just showing the notifications received from the server, we send a request so the cache gets updated
            this.getInboxItemsTotal().then(data => {
                this.notify(data);
            });
        });

        this._hubConnection.on("Error", (errorMsg: string) => this._onError.next(errorMsg));

        this._hubConnection.start();
    }

    async notify(count: number) {
        this._onUpdated.next(count);
    }

    async getInboxItemsTotal() {
        return this.handleRequest<number>(
            this.http.get<number>(`${this.url}/total`),
            this.handlersFactory.getDefault()
        );
    }
}